export function isAndroidPlatform() {
    return "android" in window;
}
export function sentAndroidRequest(req) {
    if (isAndroidPlatform()) {
        window.android.postMessage(JSON.stringify(req));
    }
    else {
        throw new Error("Invalid usage!!! Platform is not supported!!!");
    }
}
